import { Injectable } from '@angular/core';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { 
    BudgetVsActualConfigResponse, 
    GetAllBudgetVsActualConfigs, 
    SaveBudgetVsActualConfigRequest } from '../models/budget-vs-actual-config-data.model';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable()
export class BudgetVsActualConfigHttpService {

    getAllConfigurations() : Observable<GetAllBudgetVsActualConfigs> {
        let url = this.urls.getUrl("budgetvsactual/configs")
        return this.http.get<GetAllBudgetVsActualConfigs>(url);
    }
    
    getConfiguration(widgetConfigId: number) : Observable<BudgetVsActualConfigResponse> {
        let url = this.urls.getUrl(`budgetvsactual/config/${widgetConfigId}`)
        return this.http.get<BudgetVsActualConfigResponse>(url);
    }
    
    saveConfiguration(request: SaveBudgetVsActualConfigRequest) : Observable<BudgetVsActualConfigResponse> {
        let url = this.urls.getUrl("budgetvsactual/config")
        return this.http.post<BudgetVsActualConfigResponse>(url, request);
    }

    copyConfiguration(request: SaveBudgetVsActualConfigRequest) : Observable<BudgetVsActualConfigResponse> {
        let url = this.urls.getUrl("budgetvsactual/config/copy")
        return this.http.post<BudgetVsActualConfigResponse>(url, request);
    }

    constructor(
        private urls: UrlBuilderService,
        private http: HttpClient
    ) { }
}
